module.exports = __webpack_public_path__ + "static/media/ic_state_active.0b190d6d.png";